import { NextSeo } from 'next-seo';

//screens
import { WarehouseCustomerService } from '@/screens/Agents/WarehouseCustomerService';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';

export default function WarehouseCustomerServicePage() {
  return (
    <>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        canonical="https://loadsmart.com/ai/warehouse-customer-service/"
        title="Warehouse Customer Service Agent | Loadsmart AI"
        description="Answers the emails and calls your warehouse gets all day about arrivals, receipts and ship dates, books or moves appointments, and updates ETAs, using your dock schedule and your WMS."
        openGraph={{
          url: 'https://loadsmart.com/ai/warehouse-customer-service/',
        }}
      />
      <JsonLd data={Organization} />
      <WarehouseCustomerService />
    </>
  );
}
